/*
  Gallery carousel — extracted from sections/gallery.liquid so it ships from a cacheable, deferred asset
  instead of inline markup.
*/

document.addEventListener("click", function (e) {
  const btn = e.target.closest("[data-gallery-controls] .nav-prev, [data-gallery-controls] .nav-next");
  if (!btn) return;

  e.preventDefault();

  const section = btn.closest('[data-section-type="gallery"]');
  if (!section) return;

  const goPrev = btn.classList.contains("nav-prev");

  const controls = btn.closest("[data-gallery-controls]");
  const isDesktopControls = controls && controls.classList.contains("gallery-controls--desktop");

  if (!isDesktopControls) {
    const slickEl = section.querySelector(".gallery--mobile-carousel.slick-initialized");
    if (slickEl && slickEl.slick && typeof slickEl.slick.slickPrev === "function") {
      if (goPrev) slickEl.slick.slickPrev();
      else slickEl.slick.slickNext();
      return;
    }
  }

  const track = section.querySelector("[data-desktop-carousel-track]");
  if (!track) return;

  const firstItem = track.querySelector(".gallery__item");
  if (!firstItem) return;

  const styles = window.getComputedStyle(track);
  const gap = parseFloat(styles.gap) || parseFloat(styles.columnGap) || 0;

  const itemW = firstItem.getBoundingClientRect().width;
  const itemsPerView = parseInt(track.getAttribute("data-items-per-view") || "1", 10);
  const delta = (itemW + gap) * itemsPerView;

  const maxScroll = track.scrollWidth - track.clientWidth;
  const current = track.scrollLeft;

  const atStart = current <= 1;
  const atEnd = current >= (maxScroll - 1);

  if (!goPrev && atEnd) {
    track.scrollTo({ left: 0, behavior: "smooth" });
    return;
  }

  if (goPrev && atStart) {
    track.scrollTo({ left: maxScroll, behavior: "smooth" });
    return;
  }

  track.scrollBy({
    left: goPrev ? -delta : delta,
    behavior: "smooth"
  });
});

function updateGalleryControlPosition(section) {
  if (!section) return;

  const container = section.querySelector(".gallery-container");
  const firstMedia = section.querySelector(".gallery__media");
  if (!container || !firstMedia) return;

  const cRect = container.getBoundingClientRect();
  const mRect = firstMedia.getBoundingClientRect();

  const top = mRect.top - cRect.top;
  const height = mRect.height;

  section.style.setProperty("--gallery-media-top", `${top}px`);
  section.style.setProperty("--gallery-media-height", `${height}px`);
}
function normalizeDesktopCarousel(section) {

  if (!window.matchMedia("(min-width: 768px)").matches) return;

  const gallery = section.querySelector(".gallery.gallery--desktop-carousel");
  if (!gallery) return;

  const rows = gallery.querySelectorAll(".gallery__row");
  if (rows.length <= 1) return;

  const targetRow = rows[0];

  for (let i = 1; i < rows.length; i++) {
    rows[i].querySelectorAll(".gallery__item").forEach((item) => {
      targetRow.appendChild(item);
    });
    rows[i].remove();
  }

  if (!targetRow.hasAttribute("data-desktop-carousel-track")) {
    targetRow.setAttribute("data-desktop-carousel-track", "");
  }
  if (!targetRow.getAttribute("data-items-per-view")) {
    targetRow.setAttribute("data-items-per-view", gallery.getAttribute("data-grid") || "1");
  }
}
function updateAllGalleryControls() {
  document.querySelectorAll('[data-section-type="gallery"]').forEach((section) => {
    normalizeDesktopCarousel(section);
    updateGalleryControlPosition(section);
  });
}

document.addEventListener("DOMContentLoaded", () => {
  updateAllGalleryControls();
  window.addEventListener("resize", () => updateAllGalleryControls(), { passive: true });
  window.addEventListener("load", () => {
    updateAllGalleryControls();
    requestAnimationFrame(updateAllGalleryControls);
  }, { passive: true });
});

function scheduleGalleryControlsUpdate() {
    updateAllGalleryControls();
    requestAnimationFrame(updateAllGalleryControls);
    setTimeout(updateAllGalleryControls, 150);
    setTimeout(updateAllGalleryControls, 400);
  }

  document.addEventListener("shopify:section:load", scheduleGalleryControlsUpdate);
  document.addEventListener("shopify:section:unload", scheduleGalleryControlsUpdate);
  document.addEventListener("shopify:section:select", scheduleGalleryControlsUpdate);
  document.addEventListener("shopify:section:deselect", scheduleGalleryControlsUpdate);
  document.addEventListener("shopify:section:reorder", scheduleGalleryControlsUpdate);
  document.addEventListener("shopify:block:select", scheduleGalleryControlsUpdate);
  document.addEventListener("shopify:block:deselect", scheduleGalleryControlsUpdate);

  // When images inside a re-rendered section finish decoding/loading, re-measure
  document.addEventListener("load", function(e) {
    if (!e.target || e.target.tagName !== "IMG") return;
    const section = e.target.closest('[data-section-type="gallery"]');
    if (!section) return;
    updateGalleryControlPosition(section);
    requestAnimationFrame(() => updateGalleryControlPosition(section));
  }, true);
